var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-flex u-items-center u-h-4 u-my-5"},[_c('span',{staticClass:"u-border-t u-border-dark-5 u-flex-1 u-mr-10p"}),_c('span',{staticClass:"u-text-small u-text-dark-5 u-h-10p"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"u-border-t u-border-dark-5 u-flex-1 u-ml-10p"})])
}
var staticRenderFns = []

export { render, staticRenderFns }